import React from "react";

export function Separator1() {
	return <div className="separator-line bg-info" />;
}
